import { type Common } from '../common.js';
import { type CareGapBody } from '../models/patient/clinicalAlgorithmsData.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getCareGapData(ehrInformationId: string, lookbackDays?: number): Promise<CareGapBody> {
    const url = this.common.constructPath('/care-gap-findings/caregap-body', {
      ehrInformationId,
      lookbackDays,
    });
    return await this.common.getJSON(url);
  }
}
